import React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Clock, AlertTriangle } from "lucide-react";

interface TimeWarningProps {
  timeRemaining: number | null;
}

export const TimeWarning = React.memo(({ timeRemaining }: TimeWarningProps) => {
  if (!timeRemaining || timeRemaining > 300) return null; // Show only when ≤5 minutes

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;

  return (
    <Alert className="fixed top-4 right-4 z-50 border-orange-200 bg-orange-50 w-fit max-w-sm">
      <AlertTriangle className="h-4 w-4 text-orange-600" />
      <AlertDescription className="text-orange-800">
        <div className="flex items-center gap-2">
          <Clock className="h-4 w-4" />
          <span className="font-medium">
            Time Warning: Only {minutes}:{seconds.toString().padStart(2, "0")}{" "}
            remaining!
          </span>
        </div>
        <p className="mt-1 text-sm">
          Please submit your assessment soon, or it will be automatically
          submitted when time expires.
        </p>
      </AlertDescription>
    </Alert>
  );
});

TimeWarning.displayName = "TimeWarning";
